<template>

    <b-table-lite
        responsive
        :items="linksData"
      :fields="resolvedTableColumns"
        >
        
        <template #cell(influencer)="data">
            <template v-if="data.item.influencer && data.item.influencer.id">
                <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username" />
            </template>
            <template v-else>
                <p>Bilinmeyen Fenomen</p>
            </template>
        </template>

        <template #cell(status)="data">
        <b-badge
            pill
            :variant="`light-${resolveUserVerify(data.item)}`"
            class="text-capitalize"
        >
            {{ data.item.short_data.wait ? 'Bekleniyor' : (data.item.status ? 'Aktif' : 'Pasif') }}
        </b-badge>
        </template>
        <template #cell(total_amount)="data">
            <div class="text-right">{{ priceFormat(data.item.total_amount) }}</div>
        </template>
        <template #cell(campaign_name)="data">
          <campaign-link-btn :name="data.item.campaign_name" :route="{name:'campaign-detail',params:{id:data.item.id}}" />
    
      </template>
      
        <template #cell(image)="data" >
        <b-media
        v-b-popover.hover.right.html="popoverContent(data.item.image)"
        title="Paylaşım Görseli"
        custom-class="wide-popover"
      >
        <img :src="imagePath+'/links/thumb/'+data.item.image" style="max-width: 100px;" v-if="data.item.image">
      </b-media>
      </template>
      
      <template #cell(created_date)="data">
          {{ formatDate(data.item.created_date) }}
        </template>

         <template #cell(start_date)="data">
        {{ data.item.start_date ? formatDate(data.item.start_date) : '' }}
      </template>

      <template #cell(end_date)="data">
        {{ data.item.end_date ? formatDate(data.item.end_date) :'' }}
      </template>

        
        <template #cell(actions)="data">
        <div class="d-flex align-items-center">

          <!-- Detay Gör → dışarıda kalacak -->
          <router-link :to="getLinkName(data.item)" class="px-1">
            <feather-icon 
              v-b-tooltip.hover.v-primary
              title="Detay Gör"
              icon="EyeIcon"
              class="cursor-pointer" size="22" />
          </router-link>

          <!-- 3 Nokta Menü -->
          <b-dropdown
            right
            no-caret
            variant="link"
            toggle-class="p-0 m-0"
            class="px-1"
            boundary="viewport"
            menu-class="sublink-actions-menu"
            no-flip
          >
            <!-- 3 nokta icon -->
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="22" class="cursor-pointer" />
            </template>

            <!-- --- MENÜ İÇERİSİNDEKİ BUTONLAR --- -->

            <!-- Panoya Kopyala -->
            <b-dropdown-item @click="copyLink(data.item)">
              <feather-icon icon="CopyIcon" size="16" class="mr-1" />
              Kısa Linki Kopyala
            </b-dropdown-item>

            <!-- Düzenle -->
            <b-dropdown-item v-if="!isFenomen" @click="emitEditLink(data.item)">
              <feather-icon icon="EditIcon" size="16" class="mr-1" />
              Düzenle
            </b-dropdown-item>

            <!-- Whatsapp ile paylaş -->
            <b-dropdown-item 
              v-if="!isFenomen" 
              @click="copyLink(data.item,'whatsapp')"
            >
              <img src="@/assets/images/icons/whatsapp.png" width="16" class="mr-1">
              Whatsapp ile Paylaş
            </b-dropdown-item>

            <!-- Sil -->
            <b-dropdown-item
              v-if="!isFenomen"
              class="bg-danger"
              @click="deleteItem(data.item)"
            >
              <!-- ÇÖP KUTUSU -->
              <div v-if="data.item.is_deleted">
                <feather-icon icon="RotateCcwIcon" size="16" class="mr-1 text-white" />
                <span class="text-white">Geri Al</span>
              </div>

              <!-- ARŞİVDE -->
              <div v-else-if="data.item.is_archived">
                <feather-icon icon="ArchiveIcon" size="16" class="mr-1 text-white" />
                <span class="text-white">Arşivden Çıkar</span>
              </div>

              <!-- AKTİF -->
              <div v-else>
                <feather-icon icon="Trash2Icon" size="16" class="mr-1 text-white" />
                <span class="text-white">Sil</span>
              </div>
            </b-dropdown-item>

          </b-dropdown>
        </div>
      </template>
        
    </b-table-lite>
    
  </template>
  
  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, VBTooltip,VBPopover
  } from 'bootstrap-vue'
    import { useToast } from 'vue-toastification/composition'
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
    import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'
    import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue';
    import Swal from 'sweetalert2'
    import axiosIns from '@/axios'
import { getFinalPath } from '@core/utils/utils'
  export default {
    components: {
      
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BFormCheckbox,
      BTableLite,
  
      InfluencerLinkBtn,
      CampaignLinkBtn
    },
    directives: {
      'b-popover': VBPopover,
      'b-tooltip': VBTooltip
    },
    props: {
        linksData: {
            type: Array,
            default: []
        },
        parentTableColumns: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            tableColumns : [
                { key: 'id', sortable: true },
                { key: 'influencer', label: 'FENOMEN', sortable: true },
                { key: 'campaign_name', label: 'Paylaşım', sortable: true },
                { key: 'event_count',label:'Ziyaret', sortable: false },
                { key: 'cart_count',label:'Sepete Ekleme', sortable: false },
                { key: 'order_count',label:'Sipariş Adedi', sortable: false },
                { key: 'total_amount',label:'Sipariş Tutarı', sortable: false },
                { key: 'status', label: 'Durum'},
                { key: 'actions', label: 'Detay'},
            ],
        }
    },
    computed: {
        resolvedTableColumns() {
            const baseColumns = (this.parentTableColumns && this.parentTableColumns.length)
                ? this.parentTableColumns
                : this.tableColumns

            const data = this.linksData || []

            const hasTypeZero = data.some(item => Number(item.type) === 0)
            const hasTypeSeven = data.some(item => Number(item.type) === 7)

            // ✅ önce influencer filtresi
            let columns = hasTypeZero
                ? [...baseColumns]
                : baseColumns.filter(col => col.key !== 'influencer')

            // ✅ sonra type 7 override
            if (hasTypeSeven) {
                columns = this.replaceColumn(columns, 'campaign_name', {
                key: 'image',
                label: 'Banner Görseli',
                sortable: true
                })
            }

            return columns
        }
    },
    methods: {
        
        replaceColumn(columns, oldKey, newColumn) {
            return columns.map(col =>
                col.key === oldKey ? newColumn : col
            )
        },
        popoverContent(image) {
            const fullUrl = this.imagePath + '/links/' + image;
            return `<img src="${fullUrl}" style='max-width: 460px; display: block;'>`;
        },
        getLinkName(item) {
            let route = {
                name: '',
                params: {
                id: item.id
                }
            };

            if (item.type == 0) {
                if (item.links && item.links.length > 0) {
                route.name = "campaign-group-detail";
                route.params.id = item.group_id;
                } else {
                route.name = "campaign-detail";
                }
            } else if (item.type == 1) {
                route.name = "bio-story-detail";
            } else if (item.type == 2) {
                route.name = "bio-sms-detail";
            } else if (item.type == 3) {
                route.name = "bio-detail";
                route.params.platform_id = item.platform.id;
            }

            return route;
        },
        emitEditLink(item) {
            this.$emit("edit-link", item); // `edit-link` olayını tetikle ve link bilgisini gönder
        }
    },
    
    setup (props, { emit }) {

        const toast = useToast();
        const imagePath = getFinalPath();
        const resolveUserVerify = verify => {
            if (verify.short_data.wait == 1) return 'warning'
            if (verify.status == '0') return 'dark'
            if (verify.status == '1') return 'success'
            return 'primary'
        }

        const refreshParent = () => {
          emit('refresh-data')
        }

        const deleteItem = async (link) => {
            // Eğer link arşivdeyse -> direkt arşivden çıkar
            if (link.is_archived) {
                try {
                const res = await axiosIns.post(`/link/archive/${link.id}`);

                if (res.data.success) {
                    Swal.fire('Geri Alındı!', 'Link arşivden çıkarıldı.', 'success');
              refreshParent();
                } else {
                    Swal.fire('Hata!', res.data.error ?? 'İşlem başarısız.', 'error');
                }
                } catch (err) {
                Swal.fire('Hata!', 'Arşivden çıkarma sırasında bir hata oluştu.', 'error');
                }
                return;
            }

            // Eğer link arşivdeyse -> direkt arşivden çıkar
            if (link.is_deleted) {
                try {
                const res = await axiosIns.delete(`/link/${link.id}`);

                if (res.data.success) {
                    Swal.fire('Geri Alındı!', 'Link çöp kutusundan çıkarıldı.', 'success');
                refreshParent();
                } else {
                    Swal.fire('Hata!', res.data.error ?? 'İşlem başarısız.', 'error');
                }
                } catch (err) {
                Swal.fire('Hata!', 'Çöp kutusundan çıkarma sırasında bir hata oluştu.', 'error');
                }
                return;
            }

            // Arşivli değilse -> normal sil/arsiv logic
            const onlyArchive = link.event_count > 0;

            Swal.fire({
                title: onlyArchive ? 'Arşive Kaldır' : 'İşlem Seçin',
                text: onlyArchive 
                ? 'Bu link silinemez. Arşive kaldırmak ister misiniz?' 
                : 'Bu link için ne yapmak istiyorsunuz?',
                icon: 'question',

                showCancelButton: true,
                showDenyButton: true,
                showConfirmButton: !onlyArchive,

                confirmButtonText: 'Çöp Kutusuna Gönder',
                denyButtonText: 'Arşive Kaldır',
                cancelButtonText: 'Vazgeç',

                customClass: {
                actions: 'swal-actions-spacing'
                },

                confirmButtonColor: '#d33',
                denyButtonColor: '#f0ad4e',
            })
            .then(async (result) => {

                // ************ ARŞİVLE ************
                if (result.isDenied) {
                const res = await axiosIns.post(`/link/archive/${link.id}`);
                
                if (res.data.success) {
                    Swal.fire('Arşivlendi!', 'Link arşive kaldırıldı.', 'success');
                  refreshParent();
                } else {
                    Swal.fire('Hata!', res.data.error ?? 'Arşivleme hatası.', 'error');
                }
                return;
                }

                if (onlyArchive) return;

                // ************ SİL ************
                if (result.isConfirmed) {
                const res = await axiosIns.delete(`/link/${link.id}`);

                if (res.data.success) {
                    Swal.fire('Silindi!', 'Link çöp kutusuna gönderildi.', 'success');
                  refreshParent();
                } else {
                    Swal.fire('Hata!', res.data.error ?? 'Silme hatası.', 'error');
                }
                }

            });
            };

        const copyLink = (data,whatsapp=null) => {
            if (!data.link || !data.influencer.unique_token) {
                toast({
                component: ToastificationContent,
                position: 'bottom-right',
                props: {
                    icon: 'InfoIcon',
                    variant: 'danger',
                    title: 'Link kopyalama hatası!',
                },
                })
                return
            }
            const emptyLink = `${data.link}?utm_source=affiliate&utm_medium=fenomany&utm_campaign_secret_key=${data.secret_key}&utm_influencer=${data.influencer.unique_token}&utm_campaign=${encodeURIComponent(data.campaign_name)}&utm_term=${data.influencer.name_surname}`;
            const createlink = data.short_url ? data.short_url : emptyLink;
            if (whatsapp) {
                // Whatsapp paylaşım linki oluştur
                const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Paylaşım linki: ${createlink}`)}`;
                
                // Yeni sekmede Whatsapp linkini aç
                window.open(whatsappUrl, '_blank');
            } else {
                // Linki panoya kopyala
                navigator.clipboard.writeText(createlink)
                .then(() => {
                    toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                        icon: 'CopyIcon',
                        variant: 'success',
                        title: 'Link kopyalandı!',
                    },
                    });
                })
                .catch((err) => {
                    toast({
                    component: ToastificationContent,
                    position: 'bottom-right',
                    props: {
                        icon: 'InfoIcon',
                        variant: 'warning',
                        title: `Link kopyalanırken hata oluştu: ${err.message}`,
                    },
                    });
                });
            }

            }
    
        return {
            resolveUserVerify,
            copyLink,
            imagePath,
            deleteItem
        }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }

  ::v-deep .table-responsive {
    overflow-x: auto;
    overflow-y: visible;
  }

  ::v-deep td {
    overflow: visible;
  }

  ::v-deep .sublink-actions-menu {
    z-index: 3000 !important;
  }
  </style>
  